module.exports = __webpack_public_path__ + "static/img/Jamal-Shibasaki.fa1e17a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jamal-Shibasaki.jpg
// module id = VCzG
// module chunks = 0